<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-12 text-center">
                <h3 class="m-t-0 m-b-lg" style="color: #575757">LogBox for patients</h3>
                <div class="m-b m-t-3">
                  <h5>
                    Complete the forms online now.
                    <br><br>
                    <button type="button" class="btn btn-primary btn-lg " @click="openModal()" id="openKioskLink">Search for your doctor</button>
                  </h5>
                  <br/>
                  <h5>Complete and share your information on the go</h5>
                      <app-links :appLinks="appLinks" />
<!--                  <h4>to securely store your information for sharing<br/> with a healthcare provider in future.</h4>-->
                </div>
            </div>
        </div>
        <kiosk-modal :openModal="openKioskModal" @close="closeModal()" id="kioskModal"></kiosk-modal>
    </div>
</template>

<script>
import AppLinks from 'components/common/AppLinks';
import KioskModal from 'components/common/modals/KioskModal';

export default {
  name: 'under-construction-display',
  components: {
    AppLinks,
    KioskModal,
  },
  data: () => ({
    openKioskModal: false,
  }),
  props: {
    appLinks: {
      type: Object,
      default() {
        return {
          andriod: `${process.env.VUE_APP_PATIENT_APP_ANDROID}`,
          apple: `${process.env.VUE_APP_PATIENT_APP_ISO}`,
        };
      },
    },
  },
  methods: {
    openModal() {
      this.openKioskModal = true;
    },
    closeModal() {
      this.openKioskModal = false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// UnderConstructionDisplay.vue?74d27d00